export default __webpack_public_path__ + "fdf72bc8c7cd566aa13cb2fd5cb11410.svg";